import React from "react";

import { Header } from "@tvg/design-system";

// Utils
import { get } from "lodash";
// Store
import { useSelector } from "react-redux";
import {
  BettingInterest,
  Changes,
  JockeyChange,
  RaceTypeCodeEnum,
  SurfaceChanges
} from "@tvg/ts-types/Race";
import { getChangesEmptyStateMessage } from "../../../store/selectors";

import {
  HeaderWrapper,
  ChangesContainer,
  ChangesList
} from "./styled-components";
// Components
import SurfaceChangesList from "./SurfaceChanges";
import JockeyChanges from "./JockeyChanges";
import EmptyCaseDialogMessage from "../EmptyCaseDialogMessage";
import { RaceCardContainer } from "../styled-components";

interface ChangesCardProps {
  bettingInterests: BettingInterest[] | undefined;
  changes: Changes | undefined;
  raceTypeCode: RaceTypeCodeEnum;
}

const ChangesCard = React.forwardRef<HTMLDivElement, ChangesCardProps>(
  ({ bettingInterests, changes, raceTypeCode }, ref) => {
    const surface: SurfaceChanges = get(changes, "surface", {});
    const jockey: JockeyChange[] = get(changes, "horse.jockey", []);

    const changesEmptyMessage = useSelector(getChangesEmptyStateMessage);

    if (!changes || (!surface && !jockey)) {
      return (
        <RaceCardContainer ref={ref}>
          <EmptyCaseDialogMessage
            title={changesEmptyMessage.title}
            description={changesEmptyMessage.body}
            qaLabel="changes-empty-state"
            iconName="bets"
          />
        </RaceCardContainer>
      );
    }

    return (
      <ChangesContainer ref={ref}>
        <HeaderWrapper>
          <Header
            qaLabel="changes-header"
            tag="h3"
            color="grey.900"
            textAlign="start"
          >
            Race Changes
          </Header>
        </HeaderWrapper>
        <ChangesList>
          {surface &&
            (surface.course ||
              surface.distance ||
              surface.tempRailDistance ||
              surface.condition) && <SurfaceChangesList changes={surface} />}
          <JockeyChanges
            changes={jockey}
            bettingInterests={bettingInterests}
            raceTypeCode={raceTypeCode}
          />
        </ChangesList>
      </ChangesContainer>
    );
  }
);

export default ChangesCard;
